import { MemberCell } from '@euler/app/flows/common/components/MemberCell';
import { OrgUserRoleHelper } from '@euler/functions/OrgUserRoleHelper';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { useMemberList } from '@euler/functions/useMemberList';
import { useBottomSheetComponent } from '@euler/functions/ux/useBottomSheetComponent';
import { wrapNavigatorScreen } from '@euler/functions/wrapNavigatorScreen';
import { OrgMember } from '@euler/model/entity';
import { OrgUserRoleType } from '@euler/model/enum';
import { BottomSheetFlatList } from '@gorhom/bottom-sheet';
import { useMemo } from 'react';
import { FlatList } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

export const SelectMemberPage = wrapNavigatorScreen(
  ({
    onSelect,
    role,
  }: {
    title?: string;
    role?: OrgUserRoleType | OrgUserRoleType[];
    onSelect?: (member: OrgMember) => void;
  }) => {
    const { rpx } = useResponsiveContext();
    const insets = useSafeAreaInsets();

    const allMembers = useMemberList()!;
    const members = useMemo(() => {
      if (!role) return allMembers;
      const roles = Array.isArray(role) ? role : [role];
      return allMembers.filter(m =>
        new OrgUserRoleHelper(m.role).hasAnyRole(...roles),
      );
    }, [allMembers, role]);

    // BottomSheet specific scroll view components do not work on Web right now.
    // see https://github.com/gorhom/react-native-bottom-sheet/issues/11.
    const ListComponent = useBottomSheetComponent(
      FlatList,
      BottomSheetFlatList,
    );

    return (
      <ListComponent
        data={members}
        keyExtractor={x => String(x.id)}
        contentContainerStyle={{
          paddingLeft: rpx(12),
          paddingRight: rpx(12),
          paddingBottom: insets.bottom + rpx(15),
        }}
        renderItem={({ item, index }) => (
          <MemberCell
            member={item}
            first={index === 0}
            last={index === members.length - 1}
            onPress={member => onSelect?.(member)}
            isRoleLabelVisible
          />
        )}
      />
    );
  },
  ({ route }) => ({
    title: route.params.title ?? '选择责任人',
    cardStyle: { backgroundColor: '#fff' },
  }),
);
